import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#' },
  { label: '常见问答', href: '#faq' },
  { label: '手机观影', href: '#app' },
  { label: '用户热评', href: '#comments' },
  { label: '最新更新', href: '#updates' },
  { label: '平台优势', href: '#features' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  const handleNavClick = () => {
    setMobileOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[64px] md:h-[72px]">
          <a
            href="#"
            className="flex items-center gap-2 cursor-pointer group"
          >
            <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-movie-2-line text-xl text-background-50"></i>
            </div>
            <span className={`font-heading text-xl md:text-2xl font-bold transition-colors ${
              scrolled ? 'text-foreground-900' : 'text-background-50'
            }`}>
              麻花影院
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={`px-3 py-2 text-sm font-medium rounded-md transition-colors whitespace-nowrap cursor-pointer ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                    : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer transition-colors ${
              scrolled
                ? 'text-foreground-700 hover:bg-background-100'
                : 'text-background-50 hover:bg-white/10'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden fixed inset-0 top-[64px] bg-background-50 z-40 animate-fade-in">
          <nav className="flex flex-col p-4 gap-1">
            {navItems.map((item, idx) => (
              <a
                key={item.href}
                href={item.href}
                onClick={handleNavClick}
                className="px-4 py-3 text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg text-base font-medium transition-colors cursor-pointer"
                style={{ animationDelay: `${idx * 50}ms` }}
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}